import React from "react";
import RecaptchaModal from "../commons/recaptcha-modal";
import { useNewsletterFormCtx } from "../providers/newsletter-form.context";

const NewsletterRecaptcha = () => {
  const { recaptcha } = useNewsletterFormCtx();
  const { isOpenRecaptcha, setIsOpenRecaptcha, onRecaptchaSuccess } = recaptcha;
  return (
    <>
      <RecaptchaModal
        isOpen={isOpenRecaptcha}
        onSuccess={onRecaptchaSuccess}
        onClose={() => {
          setIsOpenRecaptcha(false);
        }}
      />
    </>
  );
};

export default NewsletterRecaptcha;
